import { createFileRoute, redirect } from '@tanstack/react-router';
import { isForecastEnabled, isXeroEnabled } from '@/lib/feature-flags';
import { FinanceGuard } from '@/components/finance/FinanceGuard';
import { ForecastView } from '@/components/finance/ForecastView';

/**
 * /finance/forecast — Forecast hub (F-013 S6). Real + flag-gated route (unchanged). Projections +
 * scenarios + a wired Break-Even calculator over the org's real Xero actuals; the forecast tools
 * land as deep-linked sub-pages (ticket 86d43w132, ported from the F-124/F-125 prototype).
 */
export const Route = createFileRoute('/finance/forecast')({
  beforeLoad: () => {
    if (!isXeroEnabled() || !isForecastEnabled()) {
      throw redirect({ to: '/finance', replace: true });
    }
  },
  component: () => (
    <FinanceGuard>
      <ForecastView />
    </FinanceGuard>
  ),
});
